import { IClinicService } from 'redux/clinicDetailsSlice';

/**
 * Resolves whether the booked service requires the patient to leave a note.
 * `serviceId` may point at a top-level service or one of its child services;
 * a child service without its own flag inherits the parent's flag.
 */
export const getIsPatientNoteRequired = (
  services: IClinicService[] | undefined,
  serviceId: string | null | undefined
): boolean => {
  if (!services || !serviceId) return false;

  for (const service of services) {
    if (service.id === serviceId) {
      return Boolean(service.isPatientNoteRequired);
    }

    const childService = service.childServices?.find(
      (item) => item.id === serviceId
    );

    if (childService) {
      return Boolean(
        childService.isPatientNoteRequired ?? service.isPatientNoteRequired
      );
    }
  }

  return false;
};
